exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.itinerary-snippet-container{position:relative\n}\n@media (min-width:40em){\n.itinerary-snippet-container{border-bottom:1px solid #d5dde2;margin-bottom:45px;padding-bottom:25px\n}\n}", ""]);

// exports
